export default "__VITE_ASSET__UarATXWp__"